"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Array$from2 = require("@babel/runtime-corejs2/core-js/array/from");
var _Symbol = require("@babel/runtime-corejs2/core-js/symbol");
var _Symbol$iterator = require("@babel/runtime-corejs2/core-js/symbol/iterator");
var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var WebexCore = _interopRequireWildcard(require("@webex/webex-core"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && o[_Symbol$iterator] || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Flag = WebexCore.WebexPlugin.extend({
  namespace: 'Flag',
  /**
   * Archive a flag
   * @param {Object} flag
   * @param {Object} options
   * @returns {Promise<Object>} Resolves with the flag archival
   */
  archive: function archive(flag, options) {
    if (!flag.url) {
      return _promise.default.reject(new Error('`flag.url` is required'));
    }
    options = options || {};
    var params = {
      method: 'PUT',
      uri: flag.url,
      options: options,
      body: {
        state: 'archived'
      }
    };
    return this.webex.request(params).then(function (res) {
      return res.body;
    });
  },
  /**
   * Flags an activity
   * @param {Object} activity
   * @param {Object} options
   * @returns {Promise<Object>} Resolves with the flag creation
   */
  create: function create(activity, options) {
    if (!activity.url) {
      return _promise.default.reject(new Error('`activity.url` is required'));
    }
    options = options || {};
    var params = {
      method: 'POST',
      service: 'userApps',
      resource: '/flags',
      options: options,
      body: {
        'conversation-url': activity.target.url,
        'flag-item': activity.url,
        state: 'flagged'
      }
    };
    return this.webex.request(params).then(function (res) {
      return res.body;
    });
  },
  /**
   * Gets a list of Flags for a user
   * @param {Object} options
   * @returns {Promise} Resolves with the fetched flags
   */
  list: function list(options) {
    options = options || {};
    var params = {
      method: 'GET',
      service: 'userApps',
      resource: '/flags',
      options: options,
      qs: {
        state: 'flagged'
      }
    };
    return this.webex.request(params).then(function (res) {
      return res.body.items;
    });
  },
  /**
   * Gets an array of activities where the status is 200
   * @param {Object} flags
   * @returns {Promise<Object>} Resolves with the activities
   * TODO: this should be implemented as a batched request when migrating to the modular sdk
   */
  mapToActivities: function mapToActivities(flags) {
    var _this = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var mapUrlActivities, _iterator, _step, flag, convoUrlRegex, activity, match, url, activities, responses;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            mapUrlActivities = new _map.default();
            _iterator = _createForOfIteratorHelper(flags);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                flag = _step.value;
                convoUrlRegex = /(.*)\/activities\//;
                activity = flag['flag-item'];
                match = convoUrlRegex.exec(activity);
                if (match) {
                  url = match[1];
                  activities = mapUrlActivities.get(url);
                  if (!activities) {
                    activities = [];
                    mapUrlActivities.set(url, activities);
                  }
                  activities.push(activity);
                } else {
                  _this.logger.warn("The activity URL has a strange format (".concat(activity, "). Ignoring it."));
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _context2.next = 5;
            return _promise.default.all((0, _from.default)(mapUrlActivities, /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
                var _ref3, convoUrl, activityUrls, params, res;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _ref3 = (0, _slicedToArray2.default)(_ref, 2), convoUrl = _ref3[0], activityUrls = _ref3[1];
                      params = {
                        method: 'POST',
                        url: "".concat(convoUrl, "/bulk_activities_fetch"),
                        body: {
                          activityUrls: activityUrls
                        }
                      };
                      _context.next = 4;
                      return _this.webex.request(params);
                    case 4:
                      res = _context.sent;
                      return _context.abrupt("return", res.body.multistatus.reduce(function (activitiesArr, statusData) {
                        if (statusData.status === '200') {
                          activitiesArr.push(statusData.data.activity);
                        }
                        return activitiesArr;
                      }, []));
                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 5:
            responses = _context2.sent;
            return _context2.abrupt("return", (0, _flatten2.default)(responses));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /**
   * Delete a flag
   * @param {Object} flag
   * @param {Object} options
   * @returns {Promise<Object>} Resolves with the flag deletion
   */
  delete: function _delete(flag, options) {
    if (!flag.url) {
      return _promise.default.reject(new Error('`flag.url` is required'));
    }
    options = options || {};
    var params = {
      method: 'DELETE',
      options: options,
      uri: flag.url
    };
    return this.request(params).then(function (res) {
      return res.body;
    });
  },
  /**
   * UnFlags an activity
   * @param {Object} flag
   * @param {Object} options
   * @returns {Promise<Object>} Resolves with the flag removal
   */
  unflag: function unflag(flag, options) {
    if (!flag.url) {
      return _promise.default.reject(new Error('`flag.url` is required'));
    }
    options = options || {};
    var params = {
      method: 'PUT',
      uri: flag.url,
      options: options,
      body: {
        state: 'unflagged'
      }
    };
    return this.webex.request(params).then(function (res) {
      return res.body;
    });
  }
});
var _default = Flag;
exports.default = _default;
//# sourceMappingURL=flag.js.map
